import { useState, KeyboardEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { MultiSelectContent, MultiSelectDropdown } from './styles'
import Checkbox from 'components/shared/Checkbox'
import MultiSelectCheckbox from './components'

export interface Option {
    id: string
    pl: string
    en: string
    uk: string
}
interface MultiSelectProps {
    checkBoxList: Option[]
    states: boolean[]
    setStates: (index: number, value: boolean) => void
    selectAllState: boolean
    selectAllHandler: () => void
    selectAllLabel: string
}

const MultiSelect = ({
    checkBoxList,
    states,
    setStates,
    selectAllState,
    selectAllHandler,
    selectAllLabel,
}: MultiSelectProps) => {
    const [isExtended, setIsExtended] = useState(false)

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) =>
        event.key === 'Enter' && setIsExtended((isExtended) => !isExtended)

    const handleToggleCheckbox = (index: number) => {
        setStates(index, !states[index])
    }

    return (
        <Box gap={24} isFullWidth={true}>
            <Box direction="row" justify="space-between" isFullWidth={true}>
                <Checkbox
                    setIsChecked={() => selectAllHandler()}
                    isChecked={selectAllState}
                    align="center"
                    testId="payment-check-mandatory-regulations-all"
                >
                    <Text variant="bodySmall" color="grayscale_900">
                        {selectAllLabel}
                    </Text>
                </Checkbox>
                <MultiSelectDropdown
                    direction="row"
                    gap={12}
                    align="center"
                    onClick={() => setIsExtended((isExtended) => !isExtended)}
                    onKeyDown={handleKeyDown}
                    data-testid={`payment-trigger-mandatory-reulations-${
                        isExtended ? 'hide' : 'show'
                    }`}
                    tabIndex={0}
                >
                    <Text variant="bodySmall" color="secondary_500">
                        {isExtended ? (
                            <FormattedMessage
                                id="global.btn.collapse"
                                defaultMessage="Zwiń"
                            />
                        ) : (
                            <FormattedMessage
                                id="global.btn.extend"
                                defaultMessage="Rozwiń"
                            />
                        )}
                    </Text>
                    <Icon
                        variant="chevron"
                        color="secondary_500"
                        rotation={isExtended ? 180 : 0}
                    />
                </MultiSelectDropdown>
            </Box>
            <MultiSelectContent
                isOpened={isExtended}
                gap={24}
                pl={[36, 24]}
                isFullWidth={true}
            >
                {checkBoxList.map((option, index) => (
                    <MultiSelectCheckbox
                        key={option.pl}
                        option={option}
                        index={index}
                        isChecked={states[index]}
                        toggleChecked={() => handleToggleCheckbox(index)}
                        isFocusable={isExtended}
                    />
                ))}
            </MultiSelectContent>
        </Box>
    )
}

export default MultiSelect
